<template>
  <div>
    <div class="filters">
      <span class="label">汇总维度：</span>
      <Select v-model="dimension" @change="handleDimensionChange">
        <Option v-for="item in dimensionList" :key="item.value" :value="item.value" :label="item.label"></Option>
      </Select>

      <span class="label" style="margin-left: 20px">展示指标：</span>
      <Select v-model="target" @change="handleTargetChange">
        <Option v-for="item in targetList" :key="item.value" :value="item.value" :label="item.label"></Option>
      </Select>
    </div>

    <div class="total">Top15（共{{ total }}）</div>
    <ChartProportion :dimension="dimension" :target="target" :dataSource="dataSource" />
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';

import ChartProportion from './components/Chart/Proportion';

import { getProportionAnalysisDimensionsList, getProportionAnalysisTargetsList } from './config/';

export default {
  components: {
    Select,
    Option,

    ChartProportion
  },

  props: {
    defaultDimension: {
      type: String,
      required: true
    },

    defaultTarget: {
      type: String,
      required: true
    },

    dataSource: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      dimension: this.defaultDimension,
      dimensionList: getProportionAnalysisDimensionsList(),
      target: this.defaultTarget,
      targetList: getProportionAnalysisTargetsList()
    };
  },

  computed: {
    total() {
      return this.dataSource ? this.dataSource.length : 0;
    }
  },

  methods: {
    handleDimensionChange(value) {
      this.$emit('change', {
        type: 'dimension',
        value
      });
    },

    handleTargetChange(value) {
      this.$emit('change', {
        type: 'target',
        value
      });
    }
  }
};
</script>

<style lang="less" scoped>
.label {
  font-size: 14px;
}

.filters {
  margin-bottom: 20px;
}

.total {
  position: absolute;
  right: 10px;
  font-size: 14px;
  color: #333;
}
</style>
